import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { Button, ConfigProvider, Form, Input } from "antd";
import { defaultAuthenticationsRepository } from "api/repositories/authentications/AuthenticationsRepository";
import SidebarLogo from "assets/images/Sidebar_logo.png";
import { AuthenticationContext } from "context/AuthenticationContext";
import React from "react";
import { FaRegUser } from "react-icons/fa";
import { IoLogIn } from "react-icons/io5";
import { MdOutlineLockClock } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { colorFormat } from "utils/format/ColorFormat";
import { getMessage } from "utils/helpersInTs/helpersInTs";
import { strings } from "utils/localizedStrings";

const Login = () => {
  const [body, setBody] = React.useState({});
  const [error, setError] = React.useState<Record<string, unknown>>({});
  const [loading, setLoading] = React.useState(false);
  const [form] = Form.useForm();
  const { getRoles } = AuthenticationContext();
  const navigate = useNavigate();

  const onChange = (e) => {
    setError({});
    setBody({ ...body, [e.target.name]: e.target.value });
  };

  const onSubmit = async () => {
    try {
      setLoading(true);
      let bodies = {
        username: form.getFieldValue("username"),
        password: form.getFieldValue("password"),
      };
      const { data } = await defaultAuthenticationsRepository?.login(bodies);
      localStorage.setItem("token", data.data.accessToken.id);
      delete data.data.accessToken;
      await getRoles().then(() => {
        navigate("/transaction-history/app-phone-recharge");
      });
    } catch (err) {
      console.log(err);
      getMessage(strings.GlobalMessage.InvalidAccount, 4, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <div className="w-full xl:w-1/3 lg:w-1/2 md:w-2/3 sm:w-2/3 rounded-lg p-6 mx-4 shadow-lg login-ui bg-gradient-to-br from-blue-700 from-30% to-white">
        <div className="flex font-bold justify-center mb-4">
          <img
            alt="avatar"
            className="h-20 w-20 shadow-xl rounded-full"
            src="https://raw.githubusercontent.com/sefyudem/Responsive-Login-Form/master/img/avatar.svg"
          />
        </div>
        <div className="w-full text-center flex justify-center items-center p-1">
          <img
            alt="main-label"
            className="w-full h-16 object-contain"
            src={SidebarLogo}
          />
        </div>
        <br />
        <div className="max-w-lg m-auto px-6 ">
          <Form form={form}>
            <div className="w-full">
              <Form.Item
                name="username"
                className="h-18 pb-1 hover:scale-105 transition-all"
                validateStatus={error.name ? "error" : undefined}
                rules={[
                  {
                    required: true,
                    type: "string",
                    message: "",
                  },
                ]}
              >
                <Input
                  size="large"
                  className="rounded"
                  prefix={<FaRegUser className="pr-1 text-xl" />}
                  placeholder={strings.GlobalPlaceholder.UserName}
                  onChange={onChange}
                />
              </Form.Item>
            </div>
            <div className="w-full">
              <Form.Item
                name="password"
                className="h-18 pb-1 hover:scale-105 transition-all"
                validateStatus={error.password ? "error" : undefined}
                rules={[
                  {
                    required: true,
                    type: "string",
                    message: "",
                  },
                ]}
                help={
                  error.password
                    ? strings.GlobalPlaceholder.Password
                    : undefined
                }
              >
                <>
                  <Input.Password
                    size="large"
                    className="rounded"
                    placeholder={strings.GlobalPlaceholder.Password}
                    prefix={<MdOutlineLockClock className="pr-1 text-2xl" />}
                    iconRender={(visible) =>
                      visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
                    }
                    onChange={onChange}
                  />
                </>
              </Form.Item>
            </div>
            <Form.Item className="text-center">
              <ConfigProvider
                theme={{
                  token: {
                    // Seed Token
                    colorPrimary: colorFormat?.Dark_Blue,
                  },
                }}
              >
                <Button
                  type="primary"
                  size="large"
                  onClick={onSubmit}
                  className="font-semibold hover:scale-105 transition-all"
                  icon={<IoLogIn className="text-xl" />}
                  loading={loading}
                  htmlType="submit"
                >
                  {strings.GlobalLabels.Login}
                </Button>
              </ConfigProvider>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default Login;
